import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import useSoilAnalyses from './useSoilAnalyses';

export default function SoilAnalysesHome() {
  const { data, isLoading, deleteOne } = useSoilAnalyses();

  const blockModeContent = () => (
    <Row xs={1} md={2} lg={3} className='g-3 mt-3'>
      {data.map((row) => (
        <Col key={row.id}>
          <Card className='h-100 border-0 shadow-sm rounded-3 hover-shadow'>
            <Card.Body>
              <Card.Title className='fw-bold text-dark'>{row?.name}</Card.Title>
              <Card.Subtitle className='mb-2 text-muted small'>
                {dateFormatter(row?.updated_at)}
              </Card.Subtitle>
              <div className='d-flex mt-3'>
                <SoilAnalysesActions id={row.id} onSoilAnalysesDelete={deleteOne} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const emptyFallback = isLoading ? null : (
    <div className='h5 text-center text-muted my-5'>
      Todavía no tenés análisis de suelo cargados.
    </div>
  );

  return (
    <div className='py-4'>
      <Container>
        {/* Encabezado */}
        <div className='text-start mb-3'>
          <h3 className='fw-bold text-dark mb-1'>
            Bienvenido al Módulo de Análisis de Suelo
          </h3>
          <p className='text-muted mb-3'>
            Aquí podés gestionar y consultar todos tus análisis cargados.
          </p>
          <Button as={Link} to='new' className='btn-soft-primary shadow-sm mt-2'>
            ➕ Cargar Nuevo Análisis
          </Button>
        </div>

        {/* Lista de análisis */}
        {data?.length > 0 ? blockModeContent() : emptyFallback}
      </Container>
    </div>
  );
}

function SoilAnalysesActions({ id, onSoilAnalysesDelete }) {
  return (
    <div className='gap-2 d-flex'>
      <Button
        variant='outline-danger'
        className='action-btn gap-2'
        onClick={() => onSoilAnalysesDelete(id)}
      >
        Eliminar
      </Button>
      <Button
        as={Link}
        variant='outline-primary'
        className='action-btn'
        to={`${id}`}
      >
        Abrir
      </Button>
    </div>
  );
}

function dateFormatter(dateString) {
  const config = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  return new Date(dateString).toLocaleString(undefined, config);
}